import type { CSSProperties } from "react";

import styles from "./TextInput.module.scss";

interface TextInputProps {
  id: string;
  value: string;
  inputType?: "text" | "number" | "date" | "time" | "datetime-local";
  placeholder?: string;
  readonly?: boolean;
  outline?: string;
  /** Inherited text-input CSS (padding, width, etc.) */
  textStyle?: CSSProperties;
  onChange: (value: string) => void;
}

export function TextInput({
  id,
  value,
  inputType = "text",
  placeholder,
  readonly,
  textStyle,
  onChange,
}: TextInputProps) {
  const inlineStyle: CSSProperties = {
    ...textStyle,
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    let val = e.target.value;
    // If it's a number input, manually restrict characters
    if (inputType === "number") {
      // Allow only numbers, a single period, and an optional leading minus sign, effectively stripping 'e', '+', etc.
      val = val.replace(/[^0-9.-]/g, "");

      // Handle minus signs: only allow at the beginning
      const isNegative = val.startsWith("-");
      val = val.replace(/-/g, "");
      if (isNegative) {
        val = "-" + val;
      }

      // Prevent multiple periods
      const parts = val.split(".");
      if (parts.length > 2) {
        val = parts[0] + "." + parts.slice(1).join("");
      }
    }
    if (val === value) return;
    onChange(val);
  };

  return (
    <input
      id={id}
      className={styles.input}
      style={inlineStyle}
      type={inputType === "number" ? "text" : inputType}
      {...(inputType === "number" ? { inputMode: "decimal" } : {})}
      value={value}
      placeholder={placeholder}
      readOnly={readonly}
      onChange={handleChange}
    />
  );
}
